import { jsx as _jsx } from "react/jsx-runtime";
import CarouselProduct from "../../../../../carousels/carousel-product/views/mobile/index.js";
const TabProductMobile = ({ tab , isLoading =false , config , defaultImage  })=>{
    const tabConfig = {
        ...config,
        ...tab.config
    };
    const itemLink = typeof tab.link === 'string' ? {
        href: tab.link
    } : tab.link ?? {
        href: ''
    };
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "TabProduct",
        children: /*#__PURE__*/ _jsx(CarouselProduct, {
            props: {
                items: tab.items,
                link: itemLink,
                config: tabConfig,
                isLoading,
                defaultImage
            }
        })
    });
};
export default TabProductMobile;

//# sourceMappingURL=index.js.map